var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h-content"},[_c('div',{staticClass:"home-wrapper",attrs:{"id":"channel"}},[_c('channel-header'),_vm._v(" "),(_vm.notSafeForWorkWarning)?_c('nsfw-warning',{attrs:{"text":_vm.text}}):_c('router-view')],1)]),_vm._v(" "),_c('div',{staticClass:"h-sidebar"},[_c('community-side-bar')],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-895ac06e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Channel.vue
// module id = 5eZR
// module chunks = 0